import { Order } from './types';

export namespace CustomMaterialTableHelpers {
  export const StableSort = <T>(
    items: T[],
    comparator: (a: T, b: T) => number
  ) => {
    const stabilizedThis = items.map((el, index) => [el, index] as [T, number]);

    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) {
        return order;
      }
      return a[1] - b[1];
    });

    return stabilizedThis.map((el) => el[0]);
  };

  export const GetComparator = (
    order: Order,
    orderBy: string
  ): ((a: { [key in string]: any }, b: { [key in string]: any }) => number) => {
    return order === 'desc'
      ? (a, b) => _descendingComparator(a, b, orderBy)
      : (a, b) => -_descendingComparator(a, b, orderBy);
  };

  const _descendingComparator = <T>(a: T, b: T, orderBy: keyof T) => {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  };
}
